import type { ColumnFiltersState, SortingState } from '@tanstack/react-table';
import { useEffect, useState } from 'react';

type UsePersistentTableStateProps = {
    defaultFilter?: ColumnFiltersState;
    defaultSorting?: SortingState;
    storageKeyPrefix: string;
};

export function usePersistentTableState({
    storageKeyPrefix,
    defaultSorting,
    defaultFilter,
}: UsePersistentTableStateProps) {
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [sorting, setSorting] = useState<SortingState>([]);

    const filtersStorageKey = `${storageKeyPrefix}Filters`;
    const sortingStorageKey = `${storageKeyPrefix}Sorting`;

    useEffect(() => {
        const storedFilters = localStorage.getItem(filtersStorageKey);
        if (storedFilters) {
            setColumnFilters(JSON.parse(storedFilters));
        } else if (defaultFilter && defaultFilter.length > 0) {
            setColumnFilters(defaultFilter);
        }

        const storedSorting = localStorage.getItem(sortingStorageKey);
        if (storedSorting) {
            setSorting(JSON.parse(storedSorting));
        } else if (defaultSorting && defaultSorting.length > 0) {
            setSorting(defaultSorting);
        }
    }, [storageKeyPrefix, defaultSorting, defaultFilter]);

    useEffect(() => {
        localStorage.setItem(filtersStorageKey, JSON.stringify(columnFilters));
    }, [columnFilters, storageKeyPrefix]);

    useEffect(() => {
        localStorage.setItem(sortingStorageKey, JSON.stringify(sorting));
    }, [sorting, storageKeyPrefix]);

    return {
        columnFilters,
        setColumnFilters,
        setSorting,
        sorting,
    };
}
